const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

function isSafeInternalRedirect(path?: string | null): path is string {
  return typeof path === 'string'
    && path.startsWith('/')
    && !path.startsWith('//')
    && !path.startsWith('/auth/login');
}

export function storeRedirectAfterLogin(path?: string | null): void {
  if (!isSafeInternalRedirect(path)) {
    return;
  }

  localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, path);
}

export function readRedirectAfterLogin(queryRedirect?: unknown): string | null {
  if (typeof queryRedirect === 'string' && isSafeInternalRedirect(queryRedirect)) {
    return queryRedirect;
  }

  const storedPath = localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
  return isSafeInternalRedirect(storedPath) ? storedPath : null;
}

export function consumeRedirectAfterLogin(queryRedirect?: unknown): string | null {
  const redirectPath = readRedirectAfterLogin(queryRedirect);
  localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
  return redirectPath;
}

